export const environment = {
  production: true,
  buildId: '2537827558617591',
  configFile: 'config.json',
};
